import { configureStore } from '@reduxjs/toolkit';
import spaceReducer from '../slices/spaceSlice'
import liveReducer from '../slices/liveSlice'

export const store = configureStore({
  reducer: {
    space: spaceReducer,
    live: liveReducer
  },
});
